export enum CriteriaSortingEnum {
  SortByPriority = 'SortByPriority',
  SortByDifficulty = 'SortByDifficulty',
  SortByDeadline = 'SortByDeadline',
  SortByEstimatedTime = 'SortByEstimatedTime',
  SortBySpentTime = 'SortBySpentTime',
}
